import type { TabSwitchTypes } from '@genial/components';
import React, { createContext, useContext } from 'react';

interface RedeemTabsContextReceivedData extends TabSwitchTypes.Props {}

interface RedeemTabsContextData extends RedeemTabsContextReceivedData {}

interface Props extends RedeemTabsContextReceivedData {
  children: React.ReactNode;
}

const RedeemTabsContext = createContext<RedeemTabsContextData>({} as RedeemTabsContextData);

const RedeemTabsProvider: React.FC<Props> = ({ children, ...props }) => {
  return <RedeemTabsContext.Provider value={{ ...props }}>{children}</RedeemTabsContext.Provider>;
};

const useRedeemTabsContext = (): RedeemTabsContextData => {
  const context = useContext(RedeemTabsContext);

  if (!context) {
    throw new Error('useRedeemTabsContext must be used within an RedeemTabsContext');
  }
  return context;
};

export { RedeemTabsProvider, useRedeemTabsContext, RedeemTabsContextData };
